import { render, staticRenderFns } from "./mypage.vue?vue&type=template&id=a1ef23f2&"
import script from "./mypage.vue?vue&type=script&lang=js&"
export * from "./mypage.vue?vue&type=script&lang=js&"
import style0 from "./mypage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mypage.vue"
export default component.exports